import { FC } from 'react'

import { BaseText } from '@trustycars/genie-ui/components/fields'
import {
  propsWithClassNames,
  toClassNames
} from '@trustycars/genie-ui/functions'

import useOTPInput from '$actions/useOTPInput'

import { container, input } from './styles.css'

export type OTPInputProps = ReturnType<typeof useOTPInput>

export const OTPInput: FC<OTPInputProps> = ({
  className,
  passwordFieldProps,
  containerRef
}) => {
  const fieldProps: typeof passwordFieldProps = {
    ...passwordFieldProps,
    inputProps: propsWithClassNames(
      passwordFieldProps.inputProps,
      input({ hasValue: !!passwordFieldProps.inputProps?.value })
    )
  }

  return (
    <article ref={containerRef} className={toClassNames(container, className)}>
      <BaseText {...fieldProps} />
    </article>
  )
}

export default OTPInput
